module.exports = __webpack_public_path__ + "static/media/logo-ceu-monny.caaccc35.png";